// src/components/Cards.jsx
import React from "react";

export function FeatureCard({ Icon, title, children }){
  return (
    <article className="card" style={{padding:20,height:"100%"}}>
      <div className="row-center" style={{gap:8,marginBottom:8}}>
        <Icon size={20} aria-hidden/>
        <h3 className="h3" style={{margin:0}}>{title}</h3>
      </div>
      <p className="small muted">{children}</p>
    </article>
  );
}

export function PriceRow({ title, price, children, href }){
  const isMailto = typeof href === "string" && href.startsWith("mailto:");

  return (
    <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:16,alignItems:"start",padding:"16px 0",borderBottom:"1px solid rgb(255 255 255 / .08)"}}>
      <div>
        <div className="h3" style={{margin:0}}>{title}</div>
        <div className="small muted">{children}</div>
      </div>
      <div style={{textAlign:"right"}}>
        <div className="h3" style={{margin:0}}>{price}</div>

        {href ? (
          <a
            className="link small"
            href={href}
            {...(!isMailto ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          >
            Email
          </a>
        ) : null}
      </div>
    </div>
  );
}

export function Testimonial({ name, quote }){
  return (
    <blockquote className="card" style={{padding:20}}>
      <p>“{quote}”</p>
      <footer className="small muted" style={{marginTop:8}}>— {name}</footer>
    </blockquote>
  );
}
